import { WixThemeVariableNames } from './wix-theme-variable';
export const isWixThemeVariable = varName => varName in WixThemeVariableNames;
export const createMultiValueReverseMap = sourceMap => {
  const reverseMap = {};
  for (const key in sourceMap) {
    const value = sourceMap[key];
    if (!reverseMap[value]) {
      reverseMap[value] = [];
    }
    reverseMap[value].push(key);
  }
  return reverseMap;
};
export const createMultiArrayValueReverseMap = sourceMap => {
  const reverseMap = {};
  for (const key in sourceMap) {
    const values = sourceMap[key];
    for (const value of values) {
      if (!reverseMap[value]) {
        reverseMap[value] = [];
      }
      reverseMap[value].push(key);
    }
  }
  return reverseMap;
};
//# sourceMappingURL=variable-utils.js.map